/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupporterDethronedNotificationActionData } from './SupporterDethronedNotificationActionData';
import {
    SupporterDethronedNotificationActionDataFromJSON,
    SupporterDethronedNotificationActionDataFromJSONTyped,
    SupporterDethronedNotificationActionDataToJSON,
} from './SupporterDethronedNotificationActionData';

/**
 * 
 * @export
 * @interface SupporterDethronedNotificationAction
 */
export interface SupporterDethronedNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof SupporterDethronedNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof SupporterDethronedNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SupporterDethronedNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {SupporterDethronedNotificationActionData}
     * @memberof SupporterDethronedNotificationAction
     */
    data: SupporterDethronedNotificationActionData;
}

/**
 * Check if a given object implements the SupporterDethronedNotificationAction interface.
 */
export function instanceOfSupporterDethronedNotificationAction(value: object): value is SupporterDethronedNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function SupporterDethronedNotificationActionFromJSON(json: any): SupporterDethronedNotificationAction {
    return SupporterDethronedNotificationActionFromJSONTyped(json, false);
}

export function SupporterDethronedNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupporterDethronedNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': SupporterDethronedNotificationActionDataFromJSON(json['data']),
    };
}

export function SupporterDethronedNotificationActionToJSON(value?: SupporterDethronedNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': SupporterDethronedNotificationActionDataToJSON(value.data),
    };
}

